import React, { useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import Modal from "../../../Common/Components/Modal/Index";

const Modals = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const [isModalOpen6, setIsModalOpen6] = useState(false);
  const [isModalOpen7, setIsModalOpen7] = useState(false);
  const [isModalOpen8, setIsModalOpen8] = useState(false);
  const [isModalOpen9, setIsModalOpen9] = useState(false);
  const [isModalOpen10, setIsModalOpen10] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const toggleModal2 = () => {
    setIsModalOpen2(!isModalOpen2);
  };
  const toggleModal3 = () => {
    setIsModalOpen3(!isModalOpen3);
  };
  const toggleModal4 = () => {
    setIsModalOpen4(!isModalOpen4);
  };
  const toggleModal6 = () => {
    setIsModalOpen6(!isModalOpen6);
  };
  const toggleModal7 = () => {
    setIsModalOpen7(!isModalOpen7);
  };
  const toggleModal8 = () => {
    setIsModalOpen8(!isModalOpen8);
  };
  const toggleModal9 = () => {
    setIsModalOpen9(!isModalOpen9);
  };
  const toggleModal10 = () => {
    setIsModalOpen10(!isModalOpen10);
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Modals" pageType="Components" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {/* Basic Modal */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Modal
            </h2>
            <div>
              <div className="flex items-center justify-center">
                <button
                  className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                  onClick={toggleModal}
                >
                  Launch modal
                </button>

                <Modal
                  isOpen={isModalOpen}
                  toggleModal={toggleModal}
                  title="Basic Modal"
                  divClass="flex items-start justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal}
                  sizeClass="relative w-full max-w-lg p-0 my-8 overflow-hidden bg-white border rounded-lg border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
          </div>

          {/* Vertically Centered */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Vertically Centered
            </h2>
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="text-black transition-all duration-300 border rounded-md btn border-light hover:bg-light hover:text-black dark:text-white dark:hover:text-black"
                  onClick={toggleModal2}
                >
                  Launch modal
                </button>

                <Modal
                  isOpen={isModalOpen2}
                  toggleModal={toggleModal2}
                  title="Vertically Centered"
                  divClass="flex items-center justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal2}
                  sizeClass="relative w-full max-w-lg p-0 my-8 overflow-hidden bg-white border rounded-lg border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
          </div>

          {/* Vertically Bottom */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Vertically Bottom
            </h2>
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="text-black transition-all duration-300 border rounded-md btn border-light hover:bg-light hover:text-black dark:text-white dark:hover:text-black"
                  onClick={toggleModal3}
                >
                  Launch modal
                </button>

                <Modal
                  isOpen={isModalOpen3}
                  toggleModal={toggleModal3}
                  title="Vertically Bottom"
                  divClass="flex items-end justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal3}
                  sizeClass="relative w-full max-w-lg p-0 my-8 overflow-hidden bg-white border rounded-lg border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
          </div>

          {/* Static Modal */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Static Modal
            </h2>
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                  onClick={toggleModal4}
                >
                  Launch modal
                </button>

                <Modal
                  isOpen={isModalOpen4}
                  toggleModal={toggleModal4}
                  title="Static Modal"
                  divClass="flex items-start justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal4}
                  sizeClass="relative w-full max-w-lg p-0 my-8 overflow-hidden bg-white border rounded-lg border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
          </div>

          {/* Removed Animation */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Removed Animation
            </h2>
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                  onClick={toggleModal4}
                >
                  Launch modal
                </button>

                <Modal
                  isOpen={isModalOpen4}
                  toggleModal={toggleModal4}
                  title="Removed Animation"
                  divClass="flex items-start justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal4}
                  sizeClass="relative w-full max-w-lg p-0 my-8 overflow-hidden bg-white border rounded-lg border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
          </div>

          {/* Scorllable Modal */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Scorllable Modal
            </h2>
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="text-black transition-all duration-300 border rounded-md btn border-light hover:bg-light hover:text-black dark:text-white dark:hover:text-black"
                  onClick={toggleModal6}
                >
                  Launch modal
                </button>

                <Modal
                  isOpen={isModalOpen6}
                  toggleModal={toggleModal6}
                  title="Scorllable Modal"
                  divClass="flex items-start justify-center min-h-screen px-4"
                  content={
                    <div className="h-48 min-h-full overflow-y-auto text-black dark:text-muted">
                      <p>Lorem Ipsum is simply dummy text of the industry.</p>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <p>Lorem Ipsum is simply dummy text of the industry.</p>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <p>Lorem Ipsum is simply dummy text of the industry.</p>
                    </div>
                  }
                  onDiscard={toggleModal6}
                  sizeClass="relative w-full max-w-lg p-0 my-8 overflow-hidden bg-white border rounded-lg border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
          </div>

          {/* Modal Sizes */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Modal Sizes
            </h2>
            <div className="flex flex-wrap justify-center gap-4">
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="text-black transition-all duration-300 border rounded-md btn border-light hover:bg-light hover:text-black dark:text-white dark:hover:text-black"
                  onClick={toggleModal7}
                >
                  Small Modal
                </button>

                <Modal
                  isOpen={isModalOpen7}
                  toggleModal={toggleModal7}
                  title="Small Modal"
                  divClass="flex items-start justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal7}
                  sizeClass="relative w-full max-w-sm p-0 my-8 overflow-hidden bg-white border rounded-lg shadow-3xl border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
            {/* Large */}
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="text-black transition-all duration-300 border rounded-md btn border-light hover:bg-light hover:text-black dark:text-white dark:hover:text-black"
                  onClick={toggleModal8}
                >
                  Large Modal
                </button>

                <Modal
                  isOpen={isModalOpen8}
                  toggleModal={toggleModal8}
                  title="Large Modal"
                  divClass="flex items-start justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal8}
                  sizeClass="relative w-full max-w-xl p-0 my-8 overflow-hidden bg-white border rounded-lg shadow-3xl border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
            {/* Extra Large */}
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="text-black transition-all duration-300 border rounded-md btn border-light hover:bg-light hover:text-black dark:text-white dark:hover:text-black"
                  onClick={toggleModal9}
                >
                  Extra Large Modal
                </button>

                <Modal
                  isOpen={isModalOpen9}
                  toggleModal={toggleModal9}
                  title="Extra Large Modal"
                  divClass="flex items-start justify-center min-h-screen px-4"
                  content="Lorem Ipsum is simply typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal9}
                  sizeClass="relative w-full max-w-5xl p-0 my-8 overflow-hidden bg-white border rounded-lg shadow-3xl border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4"
                />
              </div>
            </div>
            </div>
          </div>

          {/* Modal Fullscreen */}
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80 d-none">
              Modal Fullscreen
            </h2>
            <div x-data="modals">
              <div className="flex items-center justify-center">
                <button
                  className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                  onClick={toggleModal10}
                >
                  Full Screen Modal
                </button>

                <Modal
                  isOpen={isModalOpen10}
                  toggleModal={toggleModal10}
                  title="Modal Fullscreen"
                  divClass="flex items-start justify-center min-h-screen"
                  content="Lorem Ipsum is simply and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
                  onDiscard={toggleModal10}
                  sizeClass="relative w-full p-0 overflow-hidden bg-white border rounded-lg shadow-3xl border-black/10 dark:bg-darklight dark:border-darkborder"
                  spaceClass="p-5 space-y-4 min-h-[calc(100vh-53px)] flex flex-col justify-between"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Modals;
